export default {
  _Lang: "French",
  MomentLang: "fr",

  Account: {
    AccountPermissions: "Autorisations de compte",
    AllDisabled: "All Disabled",
    AllEnabled: "All Enabled",
    DeleteProfile: "Supprimer l'utilisateur",
    DeleteUserGroupError: "Delete Group Error",
    EditInformation: "Modifier les informations",
    GlobalPreset: "Global Preset",
    GlobalPresetModalMessage:
      "Please confirm you wish to override current settings",
    GlobalPresetWarningMessage:
      "This will update all existing permissions settings.",
    GroupPermissions: "Autorisations de groupe",
    Permissions: "Autorisations",
    ResetPassword: "Réinitialiser le mot de passe",
    ResetPasswords: "Réinitialiser les mots de passe",
    ResetTOTPConfig: "Réinitialiser 2FA Config",
    SecurityPolicies: "Politiques de sécurité",
    BridgeMessage: "ClientHub has moved to OASIS Bridge – log in with your existing details here:",
    SecurityPolicySettings: {
      AllowPasswordRepeat:
        "Autoriser la répétition du mot de passe pendant la réinitialisation de l'expérience",
      Basedigits: "Base 10 chiffres (0-9)",
      Disabled: "Disabled",
      Enabled: "Enabled",
      Lowercaseletters: "Minuscules",
      MinimumRequired: "Minimum de trois requis",
      Minutes: "minutes",
      NotificationExpiryDays: "Expiration des notifications (jours)",
      NotificationExpirySaved: "Expiration de la notification enregistrée",
      PasswordExpiry: "Expiration du mot de passe (jours)",
      PasswordExpiryPolicy: "Politique d'expiration du mot de passe",
      PasswordLength: "Longueur du mot de passe (caractères)",
      PasswordLockoutAttempts: "Verrouillage du mot de passe (tentatives)",
      PasswordSettings: "Paramètres de mot de passe",
      PreventCompromised: "Vérifier les compromis",
      PreventPIIData: "Empêcher les données personnelles",
      SelectaTime: "Sélectionnez une heure",
      SessionTimeout: "Expiration de la session",
      SessionTimeoutSaved:
        "Le délai d'expiration de la session a été enregistré",
      Specialcharacters: "Caractères spéciaux",
      TwoFA: "Authentification à deux facteurs",
      TwoFAOptions: {
        Disabled: "Désactivé",
        Email: "Activé – Email de code envoyé à l'utilisateur",
        TOTP: "Activé - Mot de passe à usage unique via l'application Authenticator",
      },
      TwoFACodeLifespan:
        "Durée de vie du code d'authentification à deux facteurs (minutes)",
      Unicodecharacters: "Caractères Unicode",
      Update2FAConfig:
        "Two Factor Authentication configuration has been updated.",
      Update2FALifespan:
        "Two Factor Authentication Code Lifespan has been updated.",
      UpdatedPasswordExpiryPolicy: "Password Expiry Policy is updated.",
      Uppercaseletters: "Lettres capitales",
    },
    SelectGlobalPreset: "Please select a global preset",
    ThisGroupContainsUsers: "Can not delete the group because it has users",
    UpdatePreset: "Update Presets",
    UserPermissions: "User Permissions",
    ViewRoles: "View Roles",
    UserPermissions: "Autorisations utilisateur",
    Users: {
      AddUserToTheGroup: "Ajouter un utilisateur au groupe",
      AreYouSuredelete: "Etes-vous sûr que vous voulez supprimer",
      DeleteUser: "Supprimer l'utilisateur",
      EditDeleteGroup: "Modifier ou supprimer un groupe",
      EditDeleteUser: "Modifier ou supprimer un utilisateur",
      EditGroup: "Modifier le groupe",
      LockUser: "Lock User",
      Minutes: "minutes",
      NoUsersSelected: "Aucun utilisateur sélectionné",
      Reset2FAConfigurationConfirm: "Veuillez confirmer votre demande",
      Reset2FAConfigurationConfirmation:
        "Êtes-vous sûr de vouloir réinitialiser la configuration 2FA de cet utilisateur ? Lors de la prochaine connexion, l'utilisateur sera invité à reconfigurer son application d'authentification sur son appareil mobile.",
      Reset2FAConfigurationSuccess:
        "La configuration 2FA a été réinitialisée avec succès",
      ResetGroupPasswordConfirmation:
        "Vous souhaitez forcer la réinitialisation du mot de passe pour le groupe suivant:",
      ResetGroupPasswordSuccess: "Réinitialisation du mot de passe réussie",
      ResetPasswordConfirm: "Veuillez confirmer votre demande",
      ResetPasswordConfirmation:
        "Vous souhaitez forcer la réinitialisation du mot de passe pour l'utilisateur suivant:",
      ResetPasswordSuccess: "Réinitialisation du mot de passe avec succès",
      ThisUser: "cet utilisateur",
    },
    ViewNames: {
      ACCOUNTS: "Comptes",
      ADMIN: "Administrateur",
      BILLING: "Usage",
      DASHBOARD: "Tableau de bord",
      DOCUMENTTYPE: "Type de documents",
      DOCUMENTUPLOAD: "Téléchargement de Documents",
      METADATAKEY: "Clés de métadonnées",
      REASON: "Les raisons",
      REPORTS: "Rapports",
      RETENTION: "Rétention",
      ROLES: "Les rôles",
      SITE_PREFERENCES: "Préférences du site",
      SITEMANAGEMENT: "Gestion des dossierst",
      VIEW_DOCUPLOADPPI: "Télécharger les données correspondantes",
      WORKFLOW: "Flux de travail",
      ANNOUNCEMENTS: "Annonces",
    },
  },
  AccountPermissions: {
    EnterNewPasswordFor: "Entrez le nouveau mot de passe pour",
    Modify: "Modifier",
    Operations: "Des opérations",
    ResetPassword: "Réinitialiser le mot de passe",
    SelectAFolder: "Sélectionnez un dossier",
    View: "Vue",
  },
  Accounts: "Comptes",
  Action: "Action",
  ActiveAnnouncements: " annonces actives",
  ActiveUsers: "Total d'utilisateurs actifs",
  Add: "Ajouter",
  AddACondition: "Ajouter une condition",
  AddANewMetadataKey: "Ajouter une nouvelle clé de métadonnées",
  AddChild: "Ajouter un enfant",
  AddComment: "Ajouter un commentaire",
  AddDocument: "Ajouter un document",
  AddDocumentType: "Ajouter un type de document",
  AddedComment: "Commentaire ajouté",
  AddNewFolder: "Ajouter un nouveau dossier",
  AdditionalInformation: "Additional Information",
  AdditionalInformationPlaceHolder:
    "Please provide any additional information you want added to the email here.",
  AdditionalOptions: {
    AdditionalOptions: "Options additionelles",
    Download:
      "Inclure les commentaires du document dans le document téléchargé",
    Email:
      "Inclure les commentaires du document dans le document envoyé par e-mail",
    Print: "Inclure les commentaires du document dans le document imprimé",
  },
  AddNewTextValue: "Ajouter une nouvelle valeur de texte",
  AddParentFolder: "Ajouter un parent",
  AdminPages: "Pages d'administration",
  Alias: "Alias",
  AllMetadata: "Toutes les métadonnées",
  Alpha: "Alpha",
  AlreadyExists: "existe déjà",
  Announcements: "Annonces",
  Announcement: {
    BroadcastEndDate: "Date de fin",
    BroadcastStartDate: "Date de début",
    Create: "Créer une nouvelle annonce",
    DeletionConfirmation: "Etes-vous sûr que vous voulez supprimer",
    Empty: "Aucune annonce n'existe actuellement",
    Expired: "Expiré",
    Expires: "Expire",
    Message: "Contenu",
    Pending: "Départs",
    Title: "Titre",
    Save: "Sauvegarder",
    SeverityLevel: "Gravité",
    Severity: {
      Important: "Important",
      Warning: "Avertissement",
      Information: "Information",
    },
  },
  Apply: "Apply",
  AreYouSureYouWantReset: "Are you sure you want to reset",
  AssignUpload: "Assigner et télécharger",
  AssociatedMetadata: "Métadonnées associées",
  AtleastLowercase: "Au moins un caractère minuscule",
  AtleastOneNum: "Au moins un numéro",
  AtleastSpecialChar: "Au moins un caractère spécial",
  AtleastUnicodeChar: "Au moins un caractère unicode",
  AtleastUppercase: "Au moins un caractère majuscule",
  AttachFile: "Joindre un fichier",
  Back: "retour",
  Background: "Contexte",
  BetweenChars: (min, max) => `Entre ${min} et ${max} caractères`,
  Billing: "Usage",
  Bookmark: "Signet",
  BookmarkClassification: {
    0: "Personal",
    1: "Published / Shared",
  },
  Bookmarks: "Signets",
  BookmarkTypes: {
    Personal: "Personnel",
    SharedPublished: "Publié / Partagé",
  },
  Boolean: "Oui Non",
  BothPasswordsIdentical: "Les deux mots de passe doivent être identiques",
  Browse: "Feuilleter",
  BucketSize: "Stockage total (GB)",
  BulkUploadTitle: "Hiérarchie des dossiers",
  Cancel: "Annuler",
  CancelPasswordReset: "Annuler la réinitialisation du mot de passe",
  CancelReset: "Annuler la réinitialisation du mot de passe",
  CannotCreateThisFolder: "Impossible de créer ce dossier",
  CardView: "Vue carte",
  ChangePassword: "Changer le mot de passe",
  Characters: "personnages",
  Choose: "Choisir",
  ChooseDate: "Choisissez la date",
  ChooseDocType: "Choisissez le type de document",
  ChosenDocType: "Type de document sélectionné",
  ChooseDocumentType: "Choisissez le type de document",
  ChooseLocation: "Choisissez un emplacement",
  ChosenLocation: "Dossier sélectionné",
  Clear: "Nette",
  ClearAll: "Tout effacer",
  Click: "Cliquez",
  ClickingContinue: "Clicking continue below will redirect you",
  ClientForms: {
    ClientOrder: {
      Fields: {
        accountNumber: "Numéro de compte",
        additionalInformation: "Informations Complémentaires",
        addressLine1: "Ligne d'adresse 1",
        addressLine2: "Ligne d'adresse 2",
        addressLine3: "Ligne d'adresse 3",
        authorisedBy: "Autorisé par",
        barcode: "Code à barre",
        company: "Compagnie",
        contactName: "Nom du contact",
        department: "Département",
        destroyDate: "Date de destruction",
        driverInstructions: "Instructions du conducteur",
        email: "E-mail",
        name: "Contact Name",
        phone: "Téléphoner",
        postCode: "Code postal",
        size: "Taille",
        uniqueId: "Identifiant unique",
      },
      InfoMessage:
        "Merci d'avoir soumis votre formulaire. Les informations ci-dessous ont été envoyées avec succès au groupe OASIS.",
      SubmitForm: "Soumettre le formulaire",
      Title: "Commande client",
      ValidationMessages: {
        accountNumber: "Le numéro de compte est requis.",
        addressLine1: "La ligne d'adresse 1 est obligatoire.",
        addressLine2: "La ligne d'adresse 2 est obligatoire.",
        barcode: "Le code-barres est requis.",
        company: "La société est requise.",
        contactName: "Le nom du contact est requis.",
        email: "L'e-mail est requis.",
        emailFormat: "L'e-mail doit être un e-mail valide.",
        messageMaxLength10: "Limite maximale de caractères atteinte (10)",
        messageMaxLength20: "Limite maximale de caractères atteinte (20)",
        messageMaxLength40: "Limite maximale de caractères atteinte (40)",
        messageMaxLength80: "Limite maximale de caractères atteinte(80)",
        name: "Contact name is required.",
        phone: "Le téléphone est requis.",
        postCode: "Le code postal est requis.",
      },
    },
    ContactClientCare: {
      Fields: {
        description: "La description",
        email: "E-mail",
        reason: "Raison",
      },
      InfoMessage:
        "Merci d'avoir soumis votre formulaire. Les informations ci-dessous ont été envoyées avec succès au groupe OASIS.",
      Title: "Contacter le service client",
      Reasons: [
        "Je souhaite envoyer un nouvel article en entrepôt ou organiser la livraison d'un article en entrepôt.",
        "Je souhaite mettre à jour les informations sur mes actifs actuellement stockées sur vos systèmes.",
        "Je voudrais faire détruire l'un de mes biens.",
        "Je souhaite organiser une destruction sécurisée.",
        "J'aimerais discuter de la configuration ou de l'ajustement d'une commande planifiée ou récurrente.",
        "Je souhaite acheter des produits ou des matériaux consommables auprès du groupe OASIS.",
        "Je voudrais interroger une commande que j'ai déjà passée.",
        "J'ai une question concernant mon contrat.",
        "Je souhaite organiser une formation complémentaire sur le système ClientHub.",
        "Je souhaite enregistrer un nouvel emplacement/bureau/site auprès du groupe OASIS.",
        "Je souhaite demander un rapport personnalisé.",
        "J'aimerais parler au service de contrôle du crédit.",
        "Nous envisageons de quitter le groupe OASIS et aimerions discuter du processus.",
        "Je souhaite demander une copie d'une facture historique.",
        "J'aimerais parler au service de facturation.",
        "J'ai une question concernant les prix.",
        "Je souhaite ajouter des utilisateurs supplémentaires à notre compte OASIS Group.",
      ],
      SubmitForm: "Soumettre le formulaire",
      ValidationMessages: {
        description: "La description est obligatoire.",
        email: "Un e-mail est requis.",
        emailFormat: "L'e-mail doit être un e-mail valide.",
        messageMaxLength80: "Limite maximale de caractères atteinte(80)",
        reason: "La raison est requise.",
      },
    },
    ReturnToClientForms: "Retour aux formulaires clients",
  },
  ClientHub: {
    ClientAccount: "Compte client",
    ClientAccountDetails: {
      AccountName: "Nom du compte",
      AccountCode: "Code de compte client",
      AccountEmail: "Compte email",
      Industry: "Industrie",
      MailingCity: "Ville postale",
      MailingCountry: "Pays d'envoi",
      MailingPostCode: "Envoi code postal",
      MailingStreet: "Rue postale",
      MailingStateProvince: "État d'envoi / Province",
      ReturnToClientAccount: "Retour au compte client",
      Region: "Région",
      SaveAccountDetails: "Enregistrer les détails du compte",
      TelephoneNumber: "Numéro de téléphone",
      ThankYouMessage:
        "Merci d'avoir mis à jour les détails de votre compte. Les informations ci-dessous ont été stockées avec succès.",
      Type: "Taper",
    },
    ClientFormsTitle: "Formulaires clients",
    ClientOrder: "Commande client",
    ContactClientCare: "Contacter le service client",
    ContentsManifest: "Contenu manifeste",
    Customer: "Client",
    CustomFields: "Les champs personnalisés",
    Dashboard: "Tableau de bord",
    DepartmentName: "Nom du département",
    DestructionOverview: "Aperçu de la destruction : 6 derniers mois",
    Digital: "Numérique",
    DigitalStorage: "Stockage numérique",
    DigitalStorageUsage: "Utilisation du stockage numérique",
    DownloadResults: "Télécharger les résultats",
    FormContent: {
      BriefDescriptionOfAnyActionTakenSinceDiscovery:
        "Brève description de toute mesure prise depuis la découverte",
      BriefDescriptionOfAnyActionTakenSinceDiscoveryPlaceholder:
        "Veuillez entrer une description des mesures prises",
      BriefDescriptionOfBreach: "Brève description de la violation",
      BriefDescriptionOfBreachPlaceholder:
        "Veuillez entrer toute information importante concernant la violation possible.",
      ContactEmailOfBreachReporter:
        "E-mail de contact du rapporteur de la violation",
      ContactEmailOfIncidentOwner:
        "E-mail de contact du propriétaire de l'incident",
      ContactNoOfBreachReporter: "N° de contact du rapporteur de violation",
      ContactNoOfIncidentOwner:
        "Numéro de contact du propriétaire de l'incident",
      DateOfBreach: "Date de la violation",
      DateOfDiscovery: "Date de découverte",
      LocationAffected: "Emplacement affecté",
      LocationAffectedPlaceholder:
        "Veuillez saisir des informations sur les emplacements concernés connus.",
      NameOfBreachReporter: "Nom du rapporteur de la violation",
      NameOfIncidentOwner: "Nom du propriétaire de l'incident",
      NumberOfAffectedSubjects: "Nombre de sujets affectés - si connu",
      NumberOfAffectedSubjectsPlaceholder:
        "Veuillez entrer une brève description des sujets - si connus",
      SubmitReport: "Soumettre le rapport",
      TypeOfBreach: "Type de violation",
    },
    InternalBoxReference: "Référence de la boîte interne",
    InventoryTotals: "Totaux d'inventaire",
    IssueGettingDataLineOne:
      "Un problème est survenu lors de la récupération de vos données.",
    IssueGettingDataLineTwo:
      "Veuillez contacter le service client si ce message persiste après l'actualisation",
    ItemCode: "Code de l'article",
    ItemTypeByStatus: "Type d'élément par statut",
    NoDataResult: "Aucun résultat de données",
    PendingDestruction: "En attente de destruction",
    Physical: "Physique",
    PhysicalRecordBreakdown: "Répartition des enregistrements physiques",
    PhysicalStorage: "Stockage physique",
    ReportBreach: "Signaler une violation",
    Reports: "Rapports",
    SearchOptions: "Options de recherche",
    SortBy: "Trier par",
    Status: "Statut",
    StorageSearch: "Recherche de stockage",
    ViewInOmnidox: "Voir dans Omnidox",
    ViewOnOmnidox: "Voir sur Omnidox",
    WorkOrderSubmission: "Soumission du bon de travail",
    WorkOrderType: "Type de bon de travail : 6 derniers mois",
    Year: "An",
  },
  Close: "Fermer",
  CollapseAll: "Collapse All",
  ComingSoon: "Bientôt disponible",
  Comment: "Commentaire",
  Comments: "Commentaires",
  Compartment: "Compartiment",
  CompartmentsList: "Liste des compartiments",
  Condition: "État",
  ConfigureDisplayAmount: "Configurer la quantité d'affichage",
  Confirm: "Confirmer",
  ConfirmNewPassword: "Confirmer le nouveau mot de passe",
  ConfirmOldPassword: "Confirmer l'ancien mot de passe",
  ContactUs: "Nous contacter",
  Continue: "Continue",
  ContinueTo: "Continuer vers",
  CookieConsent:
    "En utilisant cette application, vous consentez à notre utilisation des cookies conformément à notre politique en matière de cookies.",
  Create: "Créer",
  CreateAFolder: "Créer un dossier",
  CreateChild: "Créer un enfant",
  CreateChildFolderIn: "Créer un dossier enfant dans",
  CreateDocumentType: "Créer un type de document",
  CreateFolder: "Créer dossier",
  CreateGroups: "Créer des groupes",
  CreateUsers: "Créer des utilisateurs",
  Dashboard: "Dashboard",
  DataTypeHere: "Datatype hier",
  Date: "Date",
  Day: "Journéey",
  Days: "Journées",
  Decimal: "Décimal",
  Delete: "Effacer",
  DeleteComment: "Supprimer ce commentaire?",
  DeleteConfirm: "Confirm Deletion",
  DeleteData: "Suprimmer les données",
  DeletedDocument: "Document supprimé",
  DeleteFolder: "Supprimer le dossier",
  DeleteInfoMessage: "These records will be removed in 24hrs",
  DeleteNode: "Supprimer ce nœud",
  DeleteRecords: "Delete Records",
  Description: "Description",
  DeselectAll: "Tout déselectionner",
  Disabled: "Désactivé",
  Document: "Document",
  DocumentActivityHistory: "Historique de l'activité du document",
  DocumentExplorer: "Explorateur de documents",
  DocumentHistoryHeaders: {
    AddedComment: "Commentaire ajouté",
    AddedMetadata: "Métadonnées ajoutées",
    ArchivedDocument: "Marqué pour le stockage permanent",
    ConvertedAndDownloadedDocument: "Document converti et téléchargé",
    DeletedComment: "Commentaire supprimé",
    DeletedDocument: "Document supprimé",
    DocumentMarkedForDestruction: "Document marqué pour destruction",
    DocumentReadiedForRetention: "Document qualifié pour l'examen de rétention",
    DownloadedDocument: "Document téléchargé",
    DownloadedDocumentMetadata: "Métadonnées des documents téléchargés",
    EmailedDocument: "Document envoyé par e-mail",
    MatchData: "Données appariées",
    MergedAndDownloadedDocument: "Document fusionné et téléchargé",
    MovedDocument: "Document déplacé",
    PlacedDocumentBackInRetentionReview: "Renvoyé pour examen de rétention",
    PrintedDocument: "Document imprimé",
    RestoredDocument: "Restauré à partir de la corbeille",
    RetentionReviewPostponed: "Examen de rétention reporté au ",
    UnMatchData: "Données inégalées",
    UpdatedComment: "Commentaire mis à jour",
    UpdatedMetadata: "Métadonnées mises à jour",
    UploadedDocument: "Document téléchargé",
    UpsertCustomerMetadata: "Upsert Métadonnées client",
    ViewedDocument: "Document consulté",
  },
  DocumentId: "Document ID",
  DocumentIdentifier: "Identifiant de doc",
  DocumentName: "Nom du document",
  DocumentOpened: "Document ouvert",
  DocumentPrinted: "Document imprimé",
  Documents: "Type de document",
  DocumentType: "Type de document",
  DocumentTypeDeleteConfirmMessage: "Please confirm you wish to delete",
  DocumentTypeList: "Liste des types de documents",
  DocumentTypeName: "Nom du type de document",
  DocumentTypes: "Types de documents",
  DocumentUpload: "Téléchargement de documents",
  DocumentView: "Vue du document",
  Download: "Télécharger",
  Downloading: "Téléchargement...",
  DownloadOptions: "Options de téléchargement",
  DownloadOptionValues: {
    ConvertToPdfAndZip: "Convertir en PDF et Télécharger en Zip",
    StandardDownload: "Télécharger",
    DownloadMetadataAsCSV: "Télécharger les métadonnées au format CSV",
  },
  DownloadUserDetailsAsCSV:
    "Télécharger les détails de l'utilisateur au format CSV",
  DropItHot: "Déposez vos fichiers ici!",
  DropZoneInitText: "Glissez et déposez vos fichiers ici pour télécharger",
  Edit: "Modifier",
  EditBookmark: "Modifier le signet",
  EditDeleteUsers: "Modifier ou supprimer des utilisateurss",
  EditDocument: "Editer le document",
  EditFolder: "Editer le dossier",
  EditMetadataKey: "Modifier la clé de métadonnées",
  Email: "Email",
  EmailAddress: "Adresse électronique",
  EndDate: "Date de fin",
  EndDateBeforeStartDateError:
    "La date de fin est antérieure à la date de début, aucun résultat n'a pu être trouvé",
  EmailDestinations: "Email Destination(s)",
  EmailDestinationsPlaceHolder: "first@mail.com ; second@mail.com ...",
  EmailSentMessage: "L'email a été envoyé.",
  EmailUnsentMessage:
    "L'e-mail n'a pas pu être envoyé car le fichier que vous essayez d'envoyer est trop volumineux. Veuillez réessayer avec un fichier inférieur à 15 Mo.",
  EnterEmailAddress: "Entrer l'adresse e-mail",
  EnterFolderName: "Entrez le nom du dossier",
  EnterNewPassword: "Entrez un nouveau mot de passe",
  EnterTemporaryPassword: "Saisissez un mot de passe temporaire",
  EnterOldPassword: "Entrez l'ancien mot de passe",
  ErrorDocumentView:
    "Une erreur s'est produite lors de la récupération de l'affichage du document.",
  ExpandAll: "Expand All",
  Expires: "Expire",
  ExportButton: "Exporter",
  ExportToCsv: "Exporter vers CSV",
  ExporttoCSV: "Export to CSV",
  FieldType: "Type de champ",
  File: "Dossier",
  Filename: "Nom de fichier",
  FilePreviewErrorForBigFile: "File too large to preview",
  Files: "Des dossiers",
  FilesSuccessfullyUploaded: " téléchargés avec succès",
  FileTooLargePart1: "Le fichier dépasse la limite de ",
  FileTooLargePart2: " Mo.",
  Filters: "Les filtres",
  FirstSelectDocumentType: "Sélectionnez d'abord un type de document",
  Folder: "Dossier",
  FolderAndDocTypePermissionError:
    "Vous avez besoin des autorisations de type de dossier et de document.",
  FolderDeleteConfirmMessage: "Please confirm you wish to delete",
  FolderHierarchyTitle: "Hiérarchie des dossiers",
  FolderID: "ID de dossier",
  FolderName: "Nom de dossier",
  Folders: "Dossiers",
  FolderStructure: "Structure des dossiers",
  FolderUploadSuccesMessage:
    "Le fichier de téléchargement de dossier en bloc a été téléchargé avec succès pour traitement",
  FooterCopyright: "© " + new Date().getFullYear() + " OASIS Group",
  ForgotPassword: "Mot de passe oublié",
  ForgotPasswordModalTitle: "Taking you to OASIS Bridge",
  Forms: {
    AddGroup: "Ajouter un groupe",
    AddUser: "Ajouter un utilisateur",
    Department: "Département",
    FirstName: "Prénom",
    GroupName: "Nom de groupe",
    HasBeenCreated: "a été créé",
    LastLogin: "Dernière connexion",
    Location: "Emplacement",
    Mobile: "Mobile",
    MobileNumber: "Numéro de portable",
    Surname: "Nom de famille",
  },
  GetBackShortly: "Nous reviendrons vers vous sous peu",
  GiveNewName: "Donner un nouveau nom",
  GlobalSettings: "Paramètres globaux",
  Group: "Groupe",
  Groups: "Groupes",
  GroupAlreadyExists: "Group already exists",
  GroupNameIsRequired: "Group name is required",
  Help: "Aidez-moi",
  Here: "ici",
  Hidden: "Cachée",
  Hour: "Heure",
  IsClientMetadata: "Correspond aux métadonnées",
  IsDeleted: "Est supprimé",
  IsSaved: "Est sauvé",
  Language: "Langue",
  LastModified: "Dernière modification",
  LetsTakeStep: "Faisons un pas",
  Licenses: "Licenses",
  LicenseHome: "Licence Accueil",
  LinkType: "Type de lien",
  List: "Liste",
  Loading: "Chargement",
  LoadingDirectories: "Chargement de répertoires....",
  Locked: "Fermé à clé",
  Login: "S'identifier",
  LoginEmailAddressHint:
    "Veuillez saisir votre nom d'utilisateur ou votre adresse électronique",
  LoginErrorMessage: "La connexion a échoué",
  Logo: "Logo",
  LooksLikeErrorOccurred: "On dirait qu'une erreur s'est produite!",
  MarkDocumentsForDestruction: "Mark Documents for Destruction",
  markDocumentsForDestruction: "Mark for Permanent Deletion",
  MarkDocumentsrPermanentStorage: "Mark Documents for Permanent Storage",
  MarkedForPermanentDeletion: "Marked for Permanent Deletion",
  MarkForIndefiniteStorage: "Marquer pour le stockage permanent",
  Match: "Match",
  MatchData: "Données de correspondance",
  MatchDocument: "Document de correspondance",
  Matched: "Appariés",
  MatchedData: "Données appariées",
  MatchingContent: "Contenu correspondant",
  MatchResults: "Résultats du match",
  Merge: "Fusionner",
  Message: "Message",
  MessagePermanentlyDelete: "Please confirm the following",
  Metadata: "Métadonnées",
  MetadataDataType: "Data Type",
  MetadataDatekey: "Clé de date des métadonnées",
  MetadataDeleteConfirmMessage: "Please confirm you wish to delete",
  MetadataFilters: "Filtres de métadonnées",
  MetadataKeys: "Clés de métadonnées",
  MetadataKeyDeleted: "Clé de métadonnées supprimée avec succès",
  MetadataKeyLockedForEditing: "est verrouillé pour l'édition",
  MetadataKeysList: "Liste des clés de métadonnées",
  MetadataList: "Liste de métadonnées",
  MetadataMandatory: "Ces métadonnées sont-elles obligatoires?",
  MetadataName: "Nom des métadonnées",
  MetadataPrioritiesAreUpdated: "Metadata priorities are updated",
  MinutesAgo: "minutes",
  Mobile: "Mobile",
  Month: "Mois",
  MonthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  Months: "Mois",
  MoveFolder: "Move Folder",
  MultiDocuments: "documents",
  MyDashboard: "Mon Tableau de Bord",
  MyDocuments: "Mes documents",
  Name: "Nom",
  Never: "Jamais",
  New: "Nouveau",
  NewAction: "Nouvelle action",
  NewCommentAdded: "Un nouveau commentaire a été ajouté",
  NewCondition: "Nouvelle Condition",
  NewFolder: "New folder",
  No: "Non",
  NoDocuments: "Aucun Document",
  NoDocumentsAvailable: "Aucun document n'est actuellement disponible",
  NoDocumentsFoundInCurrentLocation:
    "Aucun document n'a été trouvé à l'emplacement actuel.",
  NoDocumentTypes: "Aucun type de document",
  NoMetadataDatekeys: "Aucune clé de date de métadonnées",
  NoNotificaions: "Vous n'avez aucune notification",
  NoOfActiveDocuments: "Total des enregistrements",
  NoResultForRetention:
    "No data result for this selection. Please try enter other values",
  NoResultsForSelection:
    "Aucun résultat de données pour cette sélection. Veuillez essayer d'entrer un autre",
  NotAccepted: "Type de fichier non accepté, désolé!",
  Notifications: "Avis",
  NoUsersToShow: "Aucun utilisateur à afficher...",
  Number: "Nombre",
  OfficeDocTooLargeToPreview:
    "Désolé, nous ne pouvons pas afficher les documents Microsoft Office supérieurs à 20MB!",
  OfficeDocTooLargeToPreviewDownloadInstead:
    "Veuillez télécharger ce document à la place.",
  Omnidox: "Omnidox",
  OnTheLeft: "à gauche pour trouver des documents",
  OnTheRight: "à droite pour sélectionner un document à afficher. ",
  OpenedDocument: "Document ouvert",
  Operand: "Opérande",
  Or: "Ou",
  OtherData: "Autre informations",
  Others: "Others",
  Password: "Mot de passe",
  PasswordConfirm: "Confirmez le mot de passe",
  PasswordDosentExist: "Cet email n'existe pas dans notre système.",
  PasswordInclude: "Le mot de passe doit inclure:",
  PasswordMustInclude: "Le mot de passe doit inclure",
  PasswordProtect: "Mot de passe protégé?",
  PasswordReset: "Réinitialisation du mot de passe",
  PermGroups: {
    Archive: "Archive",
    Comments: "Commentaires",
    Delete: "Supprimer",
    Document: "Document",
    DocumentMetadata: "Document et métadonnées",
    Documents: "Documents",
    Download: "Télécharger",
    Email: "Email",
    HardDelete: "Hard Delete",
    History: "Histoire",
    Import: "Importation",
    LineData: "Données de ligne",
    Mark: "Mark",
    Match: "Match",
    Move: "Bouge toi",
    MoveDocumentTo: "Déplacer le document vers",
    MoveDocumentsTo: "Déplacer Documents vers",
    Print: "Impression",
    Restore: "Restore",
    Revive: "Revive",
    Upload: "Upload",
    ViewAudit: "View Audit",
  },
  PermissionUpdate: "Group permissions are updated",
  PhysicalSearch: {
    Filters: {
      customerFilters: "Client",
      departmentFilters: "Département",
      fbufIlters: "FBU",
      itemTypeFilters: "Type d'élément",
      statusFilters: "Statut",
    },
  },
  PleaseClickForgotPassword:
    "Please click 'Forgot Password' at the top right of the page to reset your password.",
  PleaseSelect: "Veuillez choisir",
  PleaseSelectDataType: "Veuillez sélectionner le type de données",
  PleaseWait: "Veuillez patienter...",
  Possible: "possible",
  PostponeDocumentForRetentionReview:
    "Différer le document pour l'examen de la rétention",
  PostponeRetentionReview: "Différer l'examen de la rétention",
  PPIFilesSuccessfullyQueued:
    " fichiers envoyés pour traitement. Vous serez averti lorsque vous aurez terminé.",
  PPIFileSuccessfullyQueued:
    " fichier envoyé pour traitement. Vous serez averti lorsque vous aurez terminé.",
  PreparingFilesForDownload: "Préparation des fichier(s) à télécharger",
  PreparingFilesForPrinting: "Préparation des fichier(s) pour l'impression",
  PreparingFilesForEmailing:
    "Préparation des fichier(s) pour l'envoi par e-mail",
  PrintDocument: "Document d'impression",
  Printing: "Impression...",
  PrivacyPolicy: "Politique de confidentialité",
  Profile: "Profil",
  PublicallyVisible: "Commentaire public",
  PrivatelyVisible: "Commentaire privé",
  Published: "Publié",
  Reasons: {
    Reasons: "Raisons",
    Reason: "Raison",
    Includes: "Comprend",
    ExactMatch: "Exacte",
    IsMandatory: "Est obligatoire",
    EditReason: "Modifier la raison",
    LinkedOperations: "Opérations liées",
    DocumentOperations: "Opérations sur les documents",
    ReasonName: "Nom de la raison",
    AddReason: "Ajouter une raison",
    YouHaveNoReasons: "Vous n'avez encore aucune raison",
    ViewAllReasons: "Voir toutes les raisons",
  },
  RecentlyUploaded: "Téléchargé récemment",
  RecyclingBin: {
    Title: "Poubelle de recyclage",
  },
  RedirectedToOASISBridge: "You are being redirected to OASIS Bridge.",
  Remove: "Retirer",
  RemoveSortKey: "Supprimer la clé de tri",
  Rename: "Renommer",
  RepeatExpiredPasswordNotAllowed:
    "La répétition du mot de passe expiré n'est pas autorisée",
  Reports: {
    ActivityOfAuthorisedUsersWidget:
      "Activité des utilisateurs autorisés pour un client",
    ReportOfCompletedWorkOrderWidget:
      "Transactions d'ordre de travail terminées par code de service",
    ReportOfExpiredItemsReadyForDestructionWidget:
      "Expiration des conteneurs dans la plage de dates sélectionnée",
    ReportOfFileAndItemRetrievalWidget:
      "Récupérations de fichiers/éléments par client triées par",
    ReportOfInventoryStatusWidget:
      "Rapport récapitulatif sur l'état des stocks",
    ReportOfItemsWithUpcapturedDataWidget: "Articles sans description",
    ReportOfRateCards: "Carte de débit",
  },
  Required: "Obligatoires",
  Reset: "Reset",
  RestoreBtn: "Restore",
  RestoreRecords: "Restore Records",
  RestoreRecordsForReview: "Restaurer pour révision",
  Retention: {
    AddedMessage: "Une nouvelle règle de conservation est créée.",
    AddRule: "Ajouter une règle",
    CreateRetentionTitle: "Créer une règle de rétention de documents",
    DeleteRuleConfirmMessage: "Etes-vous sûr que vous voulez supprimer",
    DisableRetentionPostponement:
      "Désactiver la capacité de report des documents dans la révision de la rétention",
    DocumentRetention: "Conservation des documents",
    Retention: "Rétention",
    RetentionDuration: "Durée de conservation",
    RetentionLogic: "Logique de rétention",
    RuleActive: "Règle active",
    RuleActiveOption: "La règle est-elle active ?",
    RuleInactive: "Règle inactive",
    RuleDescription: "Description de la règle",
    RuleDescriptionPlaceholder: "Ma nouvelle règle de conservation",
    RuleName: "Nom de la règle",
    Save: "Enregistrer les paramètres",
    SelectPeriodOfTime: "Sélectionner une période de temps",
    Tab1: "Revision de document",
    Tab2: "Marqué pour suppression permanente",
    Tab3: "Marqué pour le stockage permanent",
    TimePeriod: "Période de temps",
    UpdatedMessage: "Est mis à jour.",
  },
  RetentionReviewPostponeModalText1: "Exclure le document avec l'ID ",
  RetentionReviewPostponeModalText2:
    "de tout traitement de règle de rétention jusqu'au ",
  RetentionReviewPostponeModalText3:
    "En cliquant sur Appliquer, ce document sera renvoyé dans 'Mes documents'",
  RetentionRules: "Retention Rules",
  Role: "Rôle",
  RoleFeatureAccessSaved: "Accès aux fonctionnalités mis à jour",
  ROLES: "Roles",
  Roles: {
    HeaderCreateRole: "Créer un rôle",
    RoleName: "Nom du rôle",
    RoleDesc: "Description",
    AddRole: "Ajouter un rôle",
    RoleList: "Rôles actuels",
    EditTab1: "Paramètres de base",
    EditTab2: "Accès aux fonctionnalités",
    EditTab3: "Attributions de rôles",
    Back: "retour",
    EditRole: "Enregistrer les paramètres",
    UserList: "Utilisateurs",
    GroupList: "Groupes",
    NewAssignment: "Nouvelle affectation",
    NoUserAssigned: "Il n'y a pas d'affectation d'utilisateur.",
    NoGroupAssigned: "Il n'y a pas d'affectation de groupe.",
    AddToRole: "Ajouter au rôle",
    AddUser: "Ajouter un utilisateur",
    NoUserForAssignmet: "Aucun utilisateur.",
    NoGroupForAssignmet: "Aucun groupe.",
    AddGroup: "Ajouter un groupe",
    RemoveAssignmet: "Supprimer",
    DeleteRole: "Êtes-vous sûr de vouloir supprimer",
    AddedRole: "Un nouveau rôle est ajouté.",
    UpdatedRole: "est mis à jour",
  },
  Save: "Sauver",
  SaveBookmark: "Enregistrer le signet",
  SaveDocument: "Document d'impression",
  SaveToFolder: "Enregistrer dans le dossier",
  Search: "Chercher",
  SearchBin: "Search Bin",
  SearchDocs: "Rechercher des documents",
  SearchDocumentRetention: "Search Document Retention",
  SearchFolders: "Search folders",
  SearchMarkedPermanentDeletion: "Search Marked for Permanent Deletion",
  SearchMarkedPermanentStorage: "Search Marked for Permanent Storage",
  SearchResult: "résultat",
  SearchResults: "résultats",
  SearchReturned: "revenu",
  SelectAll: "Tout sélectionner",
  SelectCategory: "Veuillez sélectionner une catégorie",
  SelectDataType: "Sélectionnez le type de données",
  SelectDocumentType: "Sélectionnez le type de document",
  SelectDownloadType: "Sélectionnez Type de téléchargement",
  Selected: "sélectionné",
  SelectFile: "Choisir le dossier",
  SelectFileText: "Dossiers de téléchargement en masse par CSV",
  SelectMetadataDatekey: "Sélectionnez une clé de date de métadonnées",
  SelectOptions: {
    ProductSupport: "Support produit",
    GeneralEnquiry: "Enquête générale",
    SuggestedImprovements: "Améliorations suggérées",
  },
  SelectWorkFlow: "Please select workflow",
  SelectYourFiles: "Sélectionnez vos fichiers",
  Send: "Send",
  SendEmailTitle: "Email your document",
  Settings: "Paramètres",
  SettingsRezMessage:
    "Les paramètres Omnidox ne sont pas accessibles à cette résolution actuelle. Veuillez utiliser une fenêtre plus grande pour continuer",
  ShowInFolder: "Afficher dans le dossier",
  ShowOnList: "Show on Table View",
  SignIn: "Se connecter",
  SignInWith: "Date de début",
  SignOut: "Déconnexion",
  SingleDocument: "document",
  SiteManagement: "Gestion des dossiers",
  SitePreferences: {
    DefaultSearchFilters: "Filtres de recherche par défaut",
    DefaultSearchFiltersLabels: {
      Comments: "Commentaires",
      Filename: "Nom de fichier",
      MatchingData: "Données appariées",
      Metadata: "Metadata",
      OCR: "OCR",
    },
    DocumentSecurity: "Sécurité des documents",
    DocumentSecurityLabels: {
      PasswordProtectBulkActionDownload:
        "Forcer les exécutions de téléchargement d'actions en masse à être protégées par un mot de passe",
      PasswordProtectBulkActionDownloadExplanation:
        "La protection par mot de passe pour le téléchargement d'actions en masse a été définie comme une exigence obligatoire par votre administrateur de site",
    },
    FolderInheritanceLabel:
      " Le dossier enfant reçoit les mêmes autorisations que son parent immédiat lors de sa création",
    Folders: "Dossiers",
    MaxPaginationResults: "Résultats par page",
    MaxSearchResults: "Résultats de recherche maximum",
    PDFLegacyMode: "Mode PDF hérité",
    PDFLegacyModeLabels: {
      EnablePDFLegacyMode:
        "Activez le mode hérité PDF. Le mode hérité du PDF permettra aux utilisateurs de contourner les fonctionnalités ci-dessous",
      PermissionsCircumvention:
        "- Téléchargement, impression et envoi par courrier électronique de documents PDF uniquement par les utilisateurs disposant des autorisations nécessaires",
      CapturingReasonsCircumvention:
        "- Capturer les raisons des opérations de téléchargement, d'impression et de courrier électronique de documents PDF",
      DocumentHistoryCircumvention:
        "- Les opérations de téléchargement, d'impression et d'envoi de documents PDF sont enregistrées dans l'historique des documents",
    },
    SaveSettings: "Enregistrer les paramètres",
    SearchResults: "Résultats de recherche",
    SearchResultLabels: {
      IncludeOcrSearchResultContext:
        "Inclure un extrait de texte OCR pertinent correspondant au terme de recherche des utilisateurs lors de l'utilisation de l'affichage des résultats de la vue de carte",
    },
    SelectDropDownOption: "Sélectionner une option",
    Title: "Préférences du site",
  },
  SomethingWrong: "Quelque chose s'est mal passé",
  Sort: "Sorte",
  SortBy: "Sort By",
  SortFolderWarning:
    "Vous êtes sur le point de réorganiser votre structure de dossiers à l'aide de la fonction Trier par ordre alphabétique. Cela supprimera tout tri personnalisé.",
  SortOrder: "Ordre de tri",
  Source: "La source",
  StartDate: "Startdatum",
  StaySignedIn: "Rester connecté",
  Subject: "Matière",
  Submit: "Soumettre",
  SuccessUploaded: "Téléchargé avec succès",
  TableView: "Vue tableau",
  Telephone: "Téléphone",
  TellUsMore: "Cliquez ici pour nous en dire plus",
  TempPasswordNotReused:
    "Le mot de passe temporaire ne peut pas être réutilisé",
  TermsConditions: "Termes et conditions",
  Text: "Texte",
  Thankyou: "Je vous remercie!",
  ThereAre: "Il y a ",
  ThisDocumentContainsNoMetadata: "Ce document ne contient pas de métadonnées",
  ThisFolderContainsFolders:
    "Ce dossier contient des dossiers, veuillez d'abord supprimer les dossiers enfants",
  ThisFolderIsEmpty: "Ce dossier est actuellement vide",
  TimeOut:
    "Le processus d'arrière-plan a expiré et a échoué. Cela est généralement dû au fait que la taille combinée des fichiers à télécharger est trop importante.",
  Tip: "Pointe",
  Title: "Titre",
  ToAddContent: "ajouter du contenu",
  ToSafety: "à la sécurité",
  Total: "TOTAL",
  TwoFAuth: {
    CancelLogin: "Annuler Connexion",
    CodeLabelPromptEmail:
      "Veuillez entrer le code à 6 chiffres de votre e-mail",
    CodeLabelPromptTOTP:
      "Veuillez saisir le code à 6 chiffres de votre application d'authentification",
    Confirm: "Confirmer",
    MessageForEmailCode: "Nous vous avons envoyé un e-mail avec un code",
    MessageForTOTPCode: "Authentification par mot de passe unique",
    SidebarMenu: {
      ConfirmationHeader: "Réinitialiser la configuration - Êtes-vous sûr?",
      FollowInstructions: "Suivez les instructions ci-dessous",
      EnterCode: "Veuillez saisir le code à 6 chiffres de votre appareil",
      Header: "Mot de passe à usage unique",
      ManageSettings: "Gérer les paramètres de mot de passe à usage unique",
      QRCodeInstructions:
        "Scannez ce code QR avec votre application Authenticator. Vous verrez apparaître un code à 6 chiffres sur votre appareil",
      SecretKeyInstructions:
        "Si vous ne pouvez pas scanner le code QR, veuillez saisir ce code texte manuellement sur votre appareil mobile",
      Success:
        "Les paramètres d'authentification à deux facteurs ont été enregistrés et vérifiés avec succès",
      WarningOne:
        "Cliquer sur 'Continuer' supprimera toute configuration existante",
      WarningTwo:
        "Vous devez suivre toutes les étapes suivantes afin de conserver l'accès à votre compte",
      WarningThree:
        "Votre code de configuration précédent ne sera plus valide, vous devez supprimer toute configuration existante de votre application Authenticator",
      WarningFour:
        "Si vous ne parvenez pas à effectuer toutes les étapes après avoir cliqué sur 'Continuer', vous ne pourrez pas vous connecter et devrez demander à un administrateur du site de réinitialiser votre configuration.",
    },
  },
  Type: "Type",
  Unknown: "l' inconnu",
  UnauthorizedPage:
    "Vos autorisations ne vous permettent pas de voir cette page",
  undefined: "indéfini",
  UnmatchData: "Supprimer les données",
  UnsupportedFileSelection: "Unsupported file selected.",
  Updated: "Actualisé",
  UpdatePriority: "Update Priority",
  UploadDocuments: "Télécharger des documents",
  UploadedBy: "Telechargé par",
  UploadedDate: "Date de téléchargement",
  UploadFiles: "Télécharger des fichiers",
  Uploading: "Téléchargement en cours...",
  UploadYourFiles: "Téléchargez vos fichiers",
  User: "utilisateur",
  UserGroupsList: "Liste des groupes d'utilisateurs",
  Username: "Nom d'utilisateur",
  Users: "Utilisateurs",
  UseThe: "Utilisez le",
  View: "View",
  ViewDocument: "Afficher le document",
  ViewNewEntries: "Voir les nouvelles entrées",
  ViewOldEntries: "Voir les anciennes entrées",
  ViewPer: "Voir par",
  Week: "La semaine",
  Weeks: "Semaines",
  Welcome: "Bienvenue",
  WelcomeToDocuments: "Bienvenue a mes documents",
  Workflow: {
    Triggers: {
      DocumentAssignedTo: "Document assigné à",
      DocumentDeleted: "Document supprimé",
      DocumentImported: "Document importé",
      DocumentMoved: "Document déplacé",
      DocumentStatusChanged: "Statut du document modifié",
      DocumentUploaded: "Document téléchargé",
      MetadataInserted: "Métadonnées insérées",
      MetadataUpdated: "Métadonnées mises à jour",
    },
    WorkflowOperand: {
      Between: "Between",
      Contains: "Contains",
      Equal: "Equal",
      GreaterThan: "Greater Than",
      GreaterThanOrEqualTo: "Greater Than Or Equal To",
      LessThan: "Less Than",
      LessThanOrEqualTo: "Less Than Or Equal To",
      None: "None",
      NotEqual: "Not Equal",
    },
  },
  WorkflowList: "Liste de flux de travail",
  WorkflowTitle: "Flux de travail",
  Years: "Ans",
  Yes: "Oui",
  YouHaveNoUsersYet: "Vous n'avez pas encore d'utilisateurs",
  YourActivityHistoryIsEmpty: "Votre historique de fichier est vide",
  YourFileHistoryIsEmpty: "Votre historique de fichier est vide",
  YourFiles: "vos fichiers",

  get Sidebar() {
    return {
      MyDocuments: this.MyDocuments,
      UploadDocuments: this.UploadDocuments,
      Settings: this.Settings,
      RecyclingBin: this.RecyclingBin.Title,
      DocumentRetention: this.Retention.DocumentRetention,
      Notifications: this.Notifications,
      ContactUs: this.ContactUs,
      Profile: this.Profile,

      Dashboard: this.Account.ViewNames.DASHBOARD,
      StorageSearch: "Recherche de stockage",
      Reports: "Rapports",
      ClientForms: "Formulaires clients",
      ClientAccount: "Compte client",
    };
  },
};
